var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClickRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 0C15.6871 0 14.8571 0.782031 14.8571 1.75C14.8571 2.71797 15.6871 3.5 16.7143 3.5H19.6567L9.83125 12.7641C9.1058 13.4477 9.1058 14.5578 9.83125 15.2414C10.5567 15.925 11.7348 15.925 12.4603 15.2414L22.2857 5.97734V8.75C22.2857 9.71797 23.1156 10.5 24.1429 10.5C25.1701 10.5 26 9.71797 26 8.75V1.75C26 0.782031 25.1701 0 24.1429 0H16.7143ZM4.64286 1.75C2.07768 1.75 0 3.70781 0 6.125V20.125C0 22.5422 2.07768 24.5 4.64286 24.5H19.5C22.0652 24.5 24.1429 22.5422 24.1429 20.125V15.75C24.1429 14.782 23.3129 14 22.2857 14C21.2585 14 20.4286 14.782 20.4286 15.75V20.125C20.4286 20.6063 20.0107 21 19.5 21H4.64286C4.13214 21 3.71429 20.6063 3.71429 20.125V6.125C3.71429 5.64375 4.13214 5.25 4.64286 5.25H9.28571C10.3129 5.25 11.1429 4.46797 11.1429 3.5C11.1429 2.53203 10.3129 1.75 9.28571 1.75H4.64286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickRoom);
export default __webpack_public_path__ + "static/media/clickRoom.c0f06bd845c7db2d66516e68a438f900.svg";
export { ForwardRef as ReactComponent };